import { useQuery } from "react-query";
import { recommendationsApi } from "@/react/api/recommendations/recommendationsApi";

export const useRecommendations = (enabled: boolean = true) =>
  useQuery("recommendations", recommendationsApi.getRecommendations, {
    enabled,
  });
